import BattleMap from '@/pages/battle-map';
export default {
  path: '/battle-map',
  title: 'battle-map',
  component: BattleMap,
  meta: {
    requiresAuth: true,
    title: '作战地图',
  }
}